import React, { useState, ChangeEvent, FormEvent } from 'react';
import { useDispatch } from 'react-redux';
import { FaSearch } from 'react-icons/fa';
import { getUsersByDNI } from '../../actions/index'

const SearchBar: React.FC = () => {
  
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [ name, setName ] = useState<string>('');

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) =>{
    setName(e.target.value);
  };

  const handleSubmit = (e: FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    dispatch(getUsersByDNI(name,token));
    setName('');
  };

 

  return (
    <div className="relative">
      <div className="flex items-center justify-end absolute left-52 top-3">
        <button
          className='search-button'
          type='submit' 
          onClick={(e: FormEvent<HTMLButtonElement>) => handleSubmit(e)}
        >
          <FaSearch size={20} className='search-icon text-slate-400' />
        </button>
      </div>
      <input
        className='border-2 w-60 border-slate-300 rounded-xl p-2 '
        type="text"
        placeholder='Search'
        value={name}
        onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputChange(e)}
      />
    </div>
  );
};

export default SearchBar;


